import React from 'react'
import PropTypes from 'prop-types'
import Chevron from '../../../assets/media/select-arrow-chlorophyll.svg?svgr-webpack'
import messages from './messages'
import { useIntl } from 'react-intl'

const UnitPicker = ({ weightUnit, heightUnit, setUnits }) => {
  const { formatMessage } = useIntl()
  const cm = formatMessage(messages.cm)
  const kg = formatMessage(messages.kg)
  const ft = formatMessage(messages.ft)
  const lbs = formatMessage(messages.lbs)
  const st = formatMessage(messages.st)

  return (
    <div className="absolute right-0 z-10 flex">
      <div className="-mr-8 rounded-full px-8 transition">
        <label
          className="leading-none text-12 font-demibold uppercase text-LSBrand"
          htmlFor="units"
        >
          <span className="sr-only">{formatMessage(messages.units)}</span>
          {`${formatMessage(messages[heightUnit])}/${formatMessage(
            messages[weightUnit],
          )}`}
          <Chevron className="relative ml-4" style={{ bottom: 2 }} width="7" />
        </label>
        <select
          data-uid="switch_units"
          id="units"
          className="top-10 absolute right-0 h-full w-full opacity-0"
          onChange={(e) => setUnits(e.target.value)}
          value={
            weightUnit === 'lbs'
              ? 'ft/lbs'
              : weightUnit === 'kg'
              ? 'cm/kg'
              : 'cm/st'
          }
        >
          <option value="ft/lbs">{`${ft}/${lbs}`}</option>
          <option value="cm/kg">{`${cm}/${kg}`}</option>
          <option value="cm/st">{`${cm}/${st}`}</option>
        </select>
      </div>
    </div>
  )
}

UnitPicker.propTypes = {
  heightUnit: PropTypes.string.isRequired,
  weightUnit: PropTypes.string.isRequired,
  setUnits: PropTypes.func.isRequired,
}

export default UnitPicker
